var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workouts"},[_c('div',{staticClass:"action-link"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/workouts/workouts"}},[_c('span',{staticClass:"material-icons"},[_vm._v("timer")]),_vm._v(" Deine Workouts ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }